import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, withCtx as _withCtx, isRef as _isRef, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mt-3"
}
const _hoisted_2 = { class: "mt-5 mb-3" }
const _hoisted_3 = { class: "mt-5 mb-3" }
const _hoisted_4 = { key: 4 }
const _hoisted_5 = { class: "mt-5 mb-3" }
const _hoisted_6 = {
  key: 1,
  class: "mt-4"
}
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }

import { watch, ref, onMounted } from 'vue';
import { useQuery } from '@vue/apollo-composable';
import { UserAccountDocument, UserType } from '@/gql/graphql';
import { BAlert, BButton, BSpinner, BCollapse } from 'bootstrap-vue-next';
import UserMfa from '@/components/user/UserMfa.vue';
import UserPersonalDetails from '@/components/user/UserPersonalDetails.vue';
import UserListOfApiKeys from '@/components/user/UserListOfApiKeys.vue';
import UserNewApiKeyForm from '@/components/user/UserNewApiKeyForm.vue';
import UserNotifications from '@/components/user/UserNotifications.vue';
import { NotificationItem } from '@/utils/notification-utils';
import { useUserStore } from '@/store/user';
import { deepParseDates } from '@/utils/date-utils';


export default /*@__PURE__*/_defineComponent({
  __name: 'PersonalInformationView',
  setup(__props) {

const userStore = useUserStore();

// --- Local State ---
const userDetails = ref<UserType>();
const newApiKeyVisible = ref(false);

// --- Query User Details ---
const {
  result: resultDetails,
  loading: loadingDetails,
  error: errorFetchDetails,
  refetch: refetchDetails,
} = useQuery(UserAccountDocument);

function setUserDetails() {
  if (resultDetails.value?.user) {
    const user = resultDetails.value.user;
    let notifications: NotificationItem[] = [];

    // If notifications are stored as a JSON string, parse them; otherwise, assume they are already an array.
    if (user.notifications) {
      try {
        notifications =
          typeof user.notifications === 'string'
            ? JSON.parse(user.notifications)
            : user.notifications;
      } catch (error) {
        console.error('Failed to parse notifications:', error);
        notifications = [];
      }
    }

    // Replace the entire object to trigger eventual watcher in child components
    userDetails.value = deepParseDates({
      ...user,
      notifications: notifications,
    }) as UserType;
  }
}

// Handle the result of the currentUser query
watch(resultDetails, (value) => {
  console.log(value);
  if (value?.user) {
    console.debug('User details retrieved');
    setUserDetails();
  } else {
    console.error('Error, could not retrieve user details.');
  }
});

function requestRefetchDetails() {
  refetchDetails()
    ?.catch((err) => {
      console.error('Refetch failed:', err);
    })
    ?.then(() => {
      console.debug('refetched');
      setUserDetails();
    });
}

// --- handle emits from child components ---
function handleUserUpdated() {
  requestRefetchDetails();
}
function handleApiKeyRevoked() {
  requestRefetchDetails();
}
function handleApiKeyCreated() {
  requestRefetchDetails();
}

// --- RE-FETCH DATA WHEN VIEW ACTIVATED ---
onMounted(() => {
  if (!loadingDetails.value && !errorFetchDetails.value) {
    setUserDetails();
  }
});

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("h1", null, [
      _createVNode(_component_font_awesome_icon, { icon: ['fas', 'user'] }),
      _cache[5] || (_cache[5] = _createTextVNode(" Account Information", -1))
    ]),
    _cache[13] || (_cache[13] = _createElementVNode("h5", null, "Manager your personal details and account settings", -1)),
    _cache[14] || (_cache[14] = _createElementVNode("hr", null, null, -1)),
    _cache[15] || (_cache[15] = _createElementVNode("p", null, " Manage your essential account information. Update your name to keep your profile current, securely change your password to protect your account, and customize your notification settings to control how you receive alerts and updates from our platform. ", -1)),
    _createVNode(_unref(BAlert), {
      modelValue: _unref(errorFetchDetails),
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(errorFetchDetails) ? (errorFetchDetails).value = $event : null)),
      variant: "danger",
      class: "mt-3",
      dismissible: ""
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(errorFetchDetails)) + " ", 1),
        _createVNode(_unref(BButton), {
          onClick: requestRefetchDetails,
          variant: "outline-dark",
          class: "btn-sm"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_font_awesome_icon, { icon: ['fas', 'sync'] }),
            _cache[6] || (_cache[6] = _createTextVNode(" Retry", -1))
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    (_unref(loadingDetails))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_unref(BSpinner), {
            small: "",
            label: "Loading..."
          })
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("h4", null, [
      _createVNode(_component_font_awesome_icon, { icon: ['fas', 'user'] }),
      _cache[7] || (_cache[7] = _createTextVNode(" Account Details ", -1))
    ]),
    (userDetails.value)
      ? (_openBlock(), _createBlock(UserPersonalDetails, {
          key: 1,
          user: userDetails.value,
          loading: _unref(loadingDetails),
          error: _unref(errorFetchDetails),
          onUserUpdated: handleUserUpdated
        }, null, 8, ["user", "loading", "error"]))
      : _createCommentVNode("", true),
    _createElementVNode("h4", _hoisted_2, [
      _createVNode(_component_font_awesome_icon, { icon: ['fas', 'shield-alt'] }),
      _cache[8] || (_cache[8] = _createTextVNode(" Multi-Factor Authentication (MFA) ", -1))
    ]),
    (userDetails.value)
      ? (_openBlock(), _createBlock(UserMfa, { key: 2 }))
      : _createCommentVNode("", true),
    _createElementVNode("h4", _hoisted_3, [
      _createVNode(_component_font_awesome_icon, { icon: ['fas', 'bell'] }),
      _cache[9] || (_cache[9] = _createTextVNode(" Notification Settings ", -1))
    ]),
    (userDetails.value && userDetails.value.notifications)
      ? (_openBlock(), _createBlock(UserNotifications, {
          key: 3,
          notifications: userDetails.value.notifications,
          loading: _unref(loadingDetails),
          onUserUpdated: handleUserUpdated
        }, null, 8, ["notifications", "loading"]))
      : _createCommentVNode("", true),
    (_unref(userStore).developer)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("h4", _hoisted_5, [
            _createVNode(_component_font_awesome_icon, { icon: ['fas', 'shield-halved'] }),
            _cache[10] || (_cache[10] = _createTextVNode(" Personal Access Tokens ", -1))
          ]),
          _createVNode(_unref(BAlert), {
            modelValue: _unref(userStore).developer,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(userStore).developer) = $event)),
            variant: "warning",
            class: "mt-3"
          }, {
            default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
              _createElementVNode("strong", null, "Warning:", -1),
              _createTextVNode(" This section is only for developers. Please proceed with caution. ", -1)
            ]))]),
            _: 1
          }, 8, ["modelValue"]),
          (userDetails.value && userDetails.value.apiKeys)
            ? (_openBlock(), _createBlock(UserListOfApiKeys, {
                key: 0,
                apiKeys: userDetails.value.apiKeys ?? [],
                loading: _unref(loadingDetails),
                error: _unref(errorFetchDetails),
                onApiKeyRevoked: handleApiKeyRevoked
              }, null, 8, ["apiKeys", "loading", "error"]))
            : _createCommentVNode("", true),
          (newApiKeyVisible.value)
            ? (_openBlock(), _createElementBlock("h4", _hoisted_6, [
                _createVNode(_component_font_awesome_icon, { icon: ['fas', 'circle-plus'] }),
                _cache[12] || (_cache[12] = _createTextVNode(" Create new access token ", -1))
              ]))
            : _createCommentVNode("", true),
          _createVNode(_unref(BCollapse), {
            id: "collapse-new-api-key",
            modelValue: newApiKeyVisible.value,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((newApiKeyVisible).value = $event))
          }, {
            default: _withCtx(() => [
              _createVNode(UserNewApiKeyForm, {
                onApiKeyCreated: handleApiKeyCreated,
                onApiKeyDismissed: _cache[2] || (_cache[2] = ($event: any) => (newApiKeyVisible.value = false))
              })
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createVNode(_unref(BButton), {
            onClick: _cache[4] || (_cache[4] = ($event: any) => (newApiKeyVisible.value = !newApiKeyVisible.value)),
            "aria-controls": "collapse-new-api-key",
            variant: "outline-dark",
            class: "my-2"
          }, {
            default: _withCtx(() => [
              (!newApiKeyVisible.value)
                ? (_openBlock(), _createElementBlock("span", _hoisted_7, "Create new access token"))
                : (_openBlock(), _createElementBlock("span", _hoisted_8, "Cancel"))
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})